export default {
  pageTitle: '立即咨询',
  heroTitle: '联系我们',
  heroSlogan: '专注跨境全链路服务，整合法律、金融与商务，护航企业出海',
  heroDesc: '专业团队为您提供一对一咨询服务，量身定制企业出海解决方案',
  formSuccessMessage: '感谢您的留言！我们会尽快与您联系。',
  companyAddressTitle: '公司地址',
  companyAddress1: '浙江省杭州市拱墅区中山北路 611 号',
  companyAddress2: '地铁商务大厦11楼 1101 室',
  contactMethodsTitle: '联系方式',
  phoneLabel: '电话',
  businessHoursTitle: '营业时间',
  businessHoursDays: '周一至周五',
  businessHoursTime: '上午9点至下午6点',
  onlineConsultation: '在线咨询',
  onlineMessageTitle: '在线留言',
  onlineMessageDesc: '填写此页面的表格后，我们将及时致电与您沟通！',
  nameLabel: '姓名',
  messageLabel: '内容',
  messagePlaceholder: '请输入您的留言...',
  submitButton: '提交',
  method1Title: '电话咨询',
  method1Desc: '工作日 9:00-17:30',
  method2Title: '微信咨询',
  method2Desc: '扫码添加微信',
  method3Title: '邮件咨询',
  method3Desc: '24小时内回复',
  method4Title: '来访预约',
  method4Content: '杭州市拱墅区中山北路611号',
  method4Desc: '地铁商务大厦1101室',
  whyChooseTitle: '为什么选择我们',
  advantage1: '20年+行业经验',
  advantage2: '专业团队服务',
  advantage3: '一站式解决方案',
  advantage4: '全球服务网络',
  officeHoursTitle: '办公时间',
  weekdays: '周一至周五',
  weekdaysTime: '9:00 - 17:30',
  saturday: '周六',
  sunday: '周日',
  closed: '休息',
  officeAddressTitle: '办公地址',
  addressLine1: '浙江省杭州市拱墅区',
  addressLine2: '中山北路611号',
  addressLine3: '地铁商务大厦1101室',
  viewMap: '查看地图',
  quickLinksTitle: '快速了解我们的服务',
  quickLinksDesc: '浏览我们的服务页面，了解如何为您的企业提供专业支持',
  businessServicesLink: '商务服务',
  legalServicesLink: '法务服务',
  aboutUsLink: '关于我们',
  ctaTitle: '准备开始您的跨境业务之旅？',
  ctaDesc: '我们的专业团队随时为您提供一对一咨询服务',
  globalNetworkTitle: '我们的全球网络',
  globalNetworkDesc: '覆盖亚太地区的服务网络，为您的跨境业务保驾护航',
}
